import { api, BASE_URL } from "../config";

const COMMERCIAL_CONTROL_URL = BASE_URL + "commercial-control/";

export function getCommercialUsage() {
    return api.get(COMMERCIAL_CONTROL_URL + "usage").then(res => res.data);
}

export function preflightCommercialAction(payload) {
    return api.post(COMMERCIAL_CONTROL_URL + "preflight", payload).then(res => res.data);
}
